import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "table-index-cell" }
const _hoisted_4 = { class: "table-index-cell__order" }
const _hoisted_5 = { class: "table-index-cell__id" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_DoiMatKhauModal = _resolveComponent("DoiMatKhauModal")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      width: "20%",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingUser)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn có chắc muốn xóa người dùng "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.deletingUser.ho_va_ten), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_DoiMatKhauModal, {
      "is-open": _ctx.isPasswordModalOpen,
      "user-id": _ctx.passwordUserId,
      "user-name": _ctx.passwordUserName,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPasswordModalOpen = false)),
      onSuccess: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refresh')))
    }, null, 8, ["is-open", "user-id", "user-name"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "Chưa có người dùng nào",
      style: {"width":"100%"},
      size: "medium",
      border: true,
      data: _ctx.items
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Họ và tên",
          "min-width": "160"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ho_va_ten), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Tên đăng nhập",
          "min-width": "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_dang_nhap), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Số điện thoại",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.so_dien_thoai), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Email",
          "min-width": "160"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.email || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Đơn vị",
          "min-width": "140"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.don_vi?.ten_don_vi || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Bộ phận",
          "min-width": "140"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.bo_phan?.ten_bo_phan || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Vai trò",
          "min-width": "140"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.roles?.length
            ? scope.row.roles.map((r) => r.name).join(', ')
            : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          width: "70",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}